import React, { useEffect } from "react";
import { connect } from "react-redux";
import PortsComponent from "./PortsComponent";
import { PortsFunction } from "../../redux/index";
import { useParams } from "react-router";

import { EndPoints } from "../../utils/EndPoints";
function PortsContainer(props) {
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    if (props.user.uid) {
      props.PortsFunction("get", EndPoints["Ports"]);
    }
  };

  const { tab, id } = useParams();
  const params = { tab: tab, id: id };
  return <PortsComponent {...props} params={params} />;
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  Ports: state.modules.Ports,
  loading: state.modules.loading,
  [EndPoints["Ports"]]: state.modules[EndPoints["Ports"]],
});
const mapDispatchToProps = {
  PortsFunction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PortsContainer);
